// 入厂不合格确认状态：
export const batchAppealList = [
  {
    valueId:'W',
    valueName:'待确认'
  },
  {
    valueId:'P',
    valueName:'认可'
  },
  {
    valueId:'F',
    valueName:'不认可'
  },
  {
    valueId:'CQ',
    valueName:'超期'
  },
]
// 现场退次确认状态
export const spotAppealList = [
  {
    valueId:'W',
    valueName:'待确认'
  },
  {
    valueId:'P',
    valueName:'认可'
  },
  {
    valueId:'F',
    valueName:'不认可'
  },
  {
    valueId:'CQ',
    valueName:'超期'
  }
]
// 入厂检验结论
export const batchTestConclusionList = [
  {
    valueId:'P',
    valueName:'合格'
  },
  {
    valueId:'F',
    valueName:'不合格'
  }
]
// 入厂终判状态
export const batchCheckList = [
  {
    valueId:'W',
    valueName:'待审核'
  },
  {
    valueId:'P',
    valueName:'非大宗商责任'
  },
  {
    valueId:'F',
    valueName:'大宗商责任'
  },
  {
    valueId:'CQ',
    valueName:'超期'
  },
]
// 现场终判状态
export const spotCheckList = [
  {
    valueId:'W',
    valueName:'待审核'
  },
  {
    valueId:'P',
    valueName:'非大宗商责任'
  },
  {
    valueId:'F',
    valueName:'大宗商责任'
  },
  {
    valueId:'CQ',
    valueName:'超期'
  }
]
// 现场退次提交状态
export const confirmStatusList = [
  {
    valueId:'N',
    valueName:'待提交'
  },
  {
    valueId:'Y',
    valueName:'已提交'
  },
  {
    valueId:'CQ',
    valueName:'超期'
  }
] 